import { anyOf, arrayOf, enumOf, is, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const isConversationalPreviewSettingsWorkflow = objectOf({
  id: string,
  name: anyOf(string, is(null)),
  status: enumOf("draft", "active"),
});

export const isConversationalPreviewSettingsWorkflowsResult = objectOf({
  eligible: arrayOf(isConversationalPreviewSettingsWorkflow),
  ineligible: arrayOf(isConversationalPreviewSettingsWorkflow),
});
